import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const EuropeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.2801 3.40409L11.6582 3.01623C11.4859 2.97502 11.3038 3.01338 11.1641 3.1203L8.72642 4.98581C8.50795 5.153 8.44136 5.4483 8.56765 5.6899L9.05518 6.62266C9.12793 6.76183 9.39513 6.72964 9.61797 6.70279C9.69835 6.69311 9.77296 6.68412 9.83059 6.68412L10.2105 6.3987L11.1641 5.47822L11.875 5.99844H11.9169V6.36475C11.9169 6.45442 11.9387 6.54282 11.9804 6.62266L12.1344 6.9174L10.9635 7.19743H9.0831C8.99498 7.19743 8.90801 7.21711 8.82884 7.25498L6.8787 8.18774C6.68001 8.28277 6.55402 8.48025 6.55402 8.69663V8.89452C6.55402 9.15264 6.87353 9.25237 7.12855 9.29234L7.17454 9.29955L6.77878 9.99569H6.15789C5.83815 9.99569 5.57895 10.2493 5.57895 10.5621V11.4335C5.57895 11.7464 5.83815 12 6.15789 12H7.23692C7.42836 12 7.60741 11.9074 7.71526 11.7527L9.04147 10.9278L9.19579 10.7802L10.779 11.5374C10.999 11.6426 11.2629 11.6011 11.438 11.4335L11.9255 10.9672C11.9535 10.9404 11.9784 10.9112 12 10.88L12.5786 11.4335C12.6868 11.537 12.8321 11.595 12.9834 11.595H14.0076C12.7843 13.6348 10.5516 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C10.1071 1 11.9968 1.931 13.2801 3.40409ZM5.57895 3C5.2592 3 5 3.25361 5 3.56645V4.45658C5 4.55688 5.02722 4.65537 5.07886 4.742L5.24296 5.01723L5.02316 5.75457C5.0078 5.80609 5 5.8595 5 5.91317V6.3987C5 6.71154 5.2592 6.96515 5.57895 6.96515H6.15789C6.36381 6.96515 6.55422 6.85814 6.65798 6.68412L7.23692 5.71306C7.34208 5.53669 7.34208 5.3186 7.23692 5.14222L6.6902 4.22521L6.42011 3.3947C6.34367 3.15964 6.12054 3 5.86842 3H5.57895Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z"
		/>
	</svg>
))
